var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"foo"}}),_c('router-view'),(_vm.isVisibleModal)?_c('modal-back-drop-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }